export default "__VITE_ASSET__RtjqevAO__"